import { Component, Input } from '@angular/core';
import { AuctionDTO } from '@shared/model/auction.model';
import { SharedModule } from '@shared/shared.module';
@Component({
	selector: 'auction-header',
	imports: [SharedModule],
	templateUrl: './auction-header.component.html',
	styleUrl: './auction-header.component.scss',
})
export class AuctionHeaderComponent {
	@Input() auction: AuctionDTO;
}